export default __webpack_public_path__ + "static/favicon-73f55f5d83d58b1bb8c2da7896745652.ico";